'use client'

import { use } from 'react'
import {
  ContextProvider,
  SuspendedContextProps,
} from './suspended-context.types'

type SuspendedContextClientProps<T> = SuspendedContextProps<T> & {
  provider: ContextProvider<T>
}

const SuspendedContextClient = <T,>({
  children,
  value,
  provider,
}: SuspendedContextClientProps<T>) => {
  const resolvedValue = value instanceof Promise ? use(value) : value
  const Provider = provider

  return <Provider value={resolvedValue}>{children}</Provider>
}

export default SuspendedContextClient
